import * as type from '../../types/API/dashboardType'

export function getItemsCount(payload: any) {
    return {
        type: type.GET_ITEMS_COUNT,
        payload: payload
    }
}

export function getStoresCount(payload: any) {
    return {
        type: type.GET_STORES_COUNT,
        payload: payload
    }
}

export function getUsersCount(payload: any) {
    return {
        type: type.GET_USERS_COUNT,
        payload: payload
    }
}

export function getDocumentsCount(payload: any) {
    return {
        type: type.GET_DOCUMENTS_COUNT,
        payload: payload
    }
}

export function getCompaniesCount(payload: any) {
    return {
        type: type.GET_COMPANIES_COUNT,
        payload: payload
    }
}

export function getItemsSalesSummary(payload: any) {
    return {
        type: type.GET_ITEMS_SALES_SUMMARY,
        payload: payload
    }
}

export function getInvoiceSummary(payload: any) {
    return {
        type: type.GET_INVOICE_SUMMARY,
        payload: payload
    }
}

export function getPredictionValue(payload: any) {
    return {
        type: type.PREDICT_NEXT_VALUE,
        payload: payload
    }
}

export function getSalesPrediction(payload: any) {
    return {
        type: type.PREDICT_SALES,
        payload: payload
    }
}

export function getItemsSalesSummaryWithPrediction(payload: any) {
    return {
        type: type.GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION,
        payload: payload
    }
}

export function getDashboardData(payload: any) {
    return {
        type: type.GET_DASHBOARD_DATA,
        payload: payload
    }
}

export function getStoreWiseItems(payload: any) {
    return {
        type: type.GET_STORE_WISE_ITEMS,
        payload: payload
    }
}

export function getCategoryWiseItems(payload: any) {
    return {
        type: type.GET_CATEGORY_WISE_ITEMS,
        payload: payload
    }
}

export function fastMovingSlowMovingItems(payload: any) {
    return {
        type: type.FAST_MOVING_SLOW_MOVING_ITEMS,
        payload: payload
    }
}

export function stockLevelAnalysis(payload: any) {
    return {
        type: type.STOCK_LEVEL_ANALYSIS,
        payload: payload
    }
}

export function stockAgeing(payload: any) {
    return {
        type: type.STOCK_AGEING,
        payload: payload
    }
}

export function workOrderStatus(payload: any) {
    return {
        type: type.WORK_ORDER_STATUS,
        payload: payload
    }
}

export function onTimeDelayProduction(payload: any) {
    return {
        type: type.ON_TIME_DELAY_PRODUCTION,
        payload: payload
    }
}

export function getSalesDashboardDetails(payload: any) {
    return {
        type: type.GET_SALES_DASHBOARD_DETAILS,
        payload: payload
    }
}